import 'slick-carousel';

$('.slider-latest-releases').each(function() {
  $(this)
    .find('.slider__slides')
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,

      infinite: true,
      prevArrow: $(this).find('.slider__nav-prev'),
      nextArrow: $(this).find('.slider__nav-next'),
      appendDots: $(this).find('.slider__nav'),
    });
});
